import styled from "styled-components";
export const StyledGameTableHeading = styled.th`
  background-color: ${(props) => props.theme.gamesTableHeading_BG} !important;
  color: ${(props) => props.theme.gamesTableHeading_text} !important;
`;

export const StyledGameOddBtn = styled.button`
    background-color: ${(props) => props.selected ? props.theme.gameOddsSelected_BG : props.theme.gameOdds_BG} !important;
    color: ${(props) => props.selected ? props.theme.gameOddsSelected_text : props.theme.superOdds_text} !important;
    border: 1px solid ${(props) => props.selected ? props.theme.gameOddsSelected_BG : props.theme.gameOdds_BG} !important;
  @media (max-width: 580px) {
    &:hover {
      background-color: ${(props) => props.theme.gameOddsSelected_BG};
      color: ${(props) => props.theme.gameOddsSelected_text};
      border: 1px solid ${(props) => props.theme.gameOddsSelected_BG};
    }
  }
  @media (min-width: 580px) {
    &:hover {
      background-color: ${(props) =>
        props.theme.gameOddsSelected_BG} !important;
      color: ${(props) => props.theme.gameOddsSelected_text} !important;
      border: 1px solid ${(props) => props.theme.gameOddsSelected_BG} !important;
    }
  }
`;